import { call, takeLatest, all, put } from '@redux-saga/core/effects';
import { FETCH_LEGACY_ORDERS } from '../actions/legacyOrders/legacyOrderActionConstants';
import {
  fetchLegacyOrdersSuccess,
  fetchLegacyOrdersError,
} from '../actions/legacyOrders/legacyOrderActions';
import { getLegacyOrders } from '../../request/legacyOrderRequest';
import { rejectErrorCodeHelper } from '../../util/helpers/rejectErrorCodeHelper';

function* fetchLegacyOrders({ payload }) {
  try {
    const { data } = yield call(getLegacyOrders, payload);
    yield put(fetchLegacyOrdersSuccess(data));
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(fetchLegacyOrdersError(errorMessage));
  }
}

export default function* legacyOrderSaga() {
  yield all([takeLatest(FETCH_LEGACY_ORDERS, fetchLegacyOrders)]);
}
